import merge from 'lodash/merge'

import { useBuilder } from '@/lib/builder/extension/useBuilder'

import type { TextFieldSection } from '../../../../types/FormBuilder.types'

const formBuilderQueue = useBuilder('formBuilder')

const TextInputCommands = {
  updateBlock: formBuilderQueue.createBlockCommand<TextFieldSection>({
    commit: async (currentData, ctx) => {
      return merge(currentData, ctx.update)
    },
  }),
}

export { TextInputCommands }
